import React from "react";

import Dashboard from "../@Components/Dashboard";
import { Col, Content, Grid, Row } from "rsuite";

import SMSDeliverySummary from "../@Components/SMS/SMSDeliverySummary";

const SMSDelivery: React.FC = () => {
  return (
    <Dashboard>
      <Grid fluid>
        <Row className="show-grid">
          <Col className="content-card chart" xs={24}>
            <Content style={{ height: "fit-content" }}>
              <SMSDeliverySummary />
            </Content>
          </Col>
        </Row>
      </Grid>
    </Dashboard>
  );
};

export default SMSDelivery;
